import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NavigationComponent } from './navigation.component';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { DirectivesModule } from '@shared/directives/directives.module';
import { SwiperModule } from 'swiper/angular';
import { TourAnchorMatMenuDirective } from 'ngx-ui-tour-md-menu';

@NgModule({
  declarations: [
    NavigationComponent
  ],
  imports: [
    CommonModule,
    MatTabsModule,
    RouterModule,
    MatMenuModule,
    MatSelectModule,
    FormsModule,
    DirectivesModule,
    SwiperModule,
    TourAnchorMatMenuDirective
  ],
  exports: [
    NavigationComponent
  ]
})
export class NavigationModule { }
